'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'mobile-screen-button';
var width = 384;
var height = 512;
var aliases = ["mobile-alt"];
var unicode = 'f3cd';
var svgPathData = 'M192 440c13.31 0 24-10.69 24-24s-10.69-24-24-24S168 402.7 168 416S178.7 440 192 440zM288 0H96c-35.35 0-64 28.65-64 64v384c0 35.35 28.65 64 64 64h192c35.35 0 64-28.65 64-64v-384C352 28.65 323.3 0 288 0zM320 448c0 17.64-14.36 32-32 32H96c-17.64 0-32-14.36-32-32v-96h256V448zM320 320H64V64c0-17.64 14.36-32 32-32h192c17.64 0 32 14.36 32 32V320z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMobileScreenButton = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/pro-light-svg-icons/faMobileScreenButton.js
// module id = IleD
// module chunks = 0